export const codeAndAmountDefaultValues = {
  isPercent: false,
  amount: null,
  name: "",
};
